import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { useMediaQuery } from '@mui/material';

import { updateGoal } from 'actions/goalApiActions';
import GoalItem from './GoalItem';
import GoalItemMobile from './GoalItemMobile';
import { Store } from 'store/storeTypes';
import {
  getGoalEntryByIdSelector,
  convertGoalTypeSelector,
  formatGoalCurrentValueSelector,
  formatGoalImpressionsValueSelector,
  goalLastUpdateNoteSelector,
  goalDateIndicatorSelector,
} from 'selectors/entitiesSelectors';

const mapStateToProps = (state: Store, props: Record<string, string | number>) => ({
  goalEntry: getGoalEntryByIdSelector(state, props),
  goalTypeStr: convertGoalTypeSelector(state, props),
  goalCurrentVal: formatGoalCurrentValueSelector(state, props),
  goalImpVal: formatGoalImpressionsValueSelector(state, props),
  lastUpdateNote: goalLastUpdateNoteSelector(state, props),
  passedDateIndicator: goalDateIndicatorSelector(state, props),
  userSettings: state.userSettings.data,
  selectedSystemGroup: state.ui.selectedSystemGroup,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      updateGoal,
    },
    dispatch
  );

export type GoalItemProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const GoalItemContainer = (props: GoalItemProps) => {
  const isDesktop = useMediaQuery('(min-width:960px)');
  return isDesktop ? <GoalItem {...props} /> : <GoalItemMobile {...props} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(GoalItemContainer);
